import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type UserState = {
  userId?: string;
  isAuthenticated?: boolean;
  clubhouseAdmin?: boolean;
};

const initialState: UserState = {
  userId: "",
  isAuthenticated: false,
  clubhouseAdmin: false,
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId(state, action: PayloadAction<{ userId: string }>): void {
      state.userId = action.payload.userId;
    },
    setIsAuthenticated(
      state,
      action: PayloadAction<{ isAuthenticated: boolean }>,
    ): void {
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    setClubhouseAdmin(
      state,
      action: PayloadAction<{ clubhouseAdmin: boolean }>,
    ): void {
      state.clubhouseAdmin = action.payload.clubhouseAdmin;
    },
  },
});

const { actions, reducer: userReducer } = slice;

const { setUserId, setIsAuthenticated, setClubhouseAdmin } = actions;

export { userReducer, setUserId, setIsAuthenticated, setClubhouseAdmin };
